import AnimationClip from '../AnimationClip';
import { Tween, Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import { delay } from '../../../Utility/Task/TaskQueue';
import UIImageComponent from '../../../Component/UI/Image';
import SpriteComponent from "Component/Render/Sprite";

export class HarvestFadeLoop extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: {
            maxWorld: number;
            duration?: number;
            delay?: number;
        }
    ): IterableIterator<number> {
        try {
            const renderable: Renderable = gameObject.getComponent(Renderable);
            let i: number = 1;
            renderable.visible = true;
            renderable.alpha = 0;
            const imageComponent = gameObject.getComponent(SpriteComponent);

            while (true) {
                if (i >= meta.maxWorld) i = 1;
                imageComponent.texture = `collect_map_${i}`;
                const fadeInTween: Tween = this.getTween(renderable);

                fadeInTween
                    .to({ alpha: 1 }, meta.duration || 500)
                    .easing(Easing.Linear.None);
                yield* this.startTween(fadeInTween);

                const fadeOutTween: Tween = this.getTween(renderable);
                yield* delay(meta.delay || 500);
                fadeOutTween
                    .to({ alpha: 0 }, meta.duration || 500)
                    .easing(Easing.Linear.None);
                yield* this.startTween(fadeOutTween);
                i++;
            }
        } catch (e) {
            console.error(e);
        }
    }
}
